import { useMemo } from 'react';
import { useLocation } from 'umi';
import {
  MINI_GAME_RANKING_KEY_LIST,
  MINI_GAME_RANKING_KEY_LIST_DOUYIN,
} from '@intelligence/v3/pages/ReusePages/CasualMiniGameRankings/config';

export default function useInitialTopChartsName() {
  const sourceKeyTmp = 'source';

  const location = useLocation();

  const topChartsName = useMemo(() => {
    const urlSearchParams = new URLSearchParams(location.search);
    const urlTopChartsName = decodeURIComponent(urlSearchParams.get(sourceKeyTmp) || '');
    if (
      MINI_GAME_RANKING_KEY_LIST.includes(urlTopChartsName) ||
      MINI_GAME_RANKING_KEY_LIST_DOUYIN.includes(urlTopChartsName)
    ) {
      return urlTopChartsName;
    }
    return MINI_GAME_RANKING_KEY_LIST[0];
  }, [location?.search]);

  return topChartsName;
}
